import { post } from "../../utils/Backend";
import { useH5Mock } from "../../global/GlobalMock";
import { mockListActiveChatStickerCatalog } from "./ChatStickerMock";
import type { ListChatStickerCatalogResult } from "./ChatStickerType";

const mockChatSticker = useH5Mock && false;

function unwrap<R>(res: R | string): R {
  if (typeof res === "string") {
    throw new Error(res);
  }
  return res;
}

export const ChatStickerApi = {
  async listActiveCatalog(): Promise<ListChatStickerCatalogResult> {
    if (mockChatSticker) {
      return mockListActiveChatStickerCatalog();
    }
    return unwrap(
      await post<Record<string, never>, ListChatStickerCatalogResult>(
        "/lark/app/chatSticker/listActiveCatalog",
        {}
      )
    );
  },
};
